export default {
  REJECTION: 'rejection',
  REQUEST_CANCELLATION: 'request_cancellation',
  SIGNING_CANCELLATION: 'signing_cancellation',
};
